import { Plus, Wrench } from "lucide-react";
import { Link } from "react-router-dom";
import { Badge, Button, Card } from "../components/ui";

const rows = [
  {
    id: "expense-1",
    asset: "Renault Kwid 2023",
    category: "MAINTENANCE",
    description: "Troca de óleo e filtros",
    value: "R$ 420,00",
    date: "18/09/2026",
    status: "PAID",
  },
  {
    id: "expense-2",
    asset: "Apartamento Centro",
    category: "PROPERTY_TAX",
    description: "IPTU — parcela 9",
    value: "R$ 310,00",
    date: "20/09/2026",
    status: "OPEN",
  },
];

export function AssetExpensesPage() {
  return (
    <Card
      title="Despesas do patrimônio"
      description="Manutenção, seguro, impostos, multas e reparos por ativo."
      action={
        <Link to="/operacoes/nova?tipo=expense">
          <Button>
            <Plus size={16} /> Nova despesa
          </Button>
        </Link>
      }
    >
      <div className="table-scroll">
        <table className="data-table">
          <thead>
            <tr>
              <th>Ativo</th>
              <th>Categoria</th>
              <th>Descrição</th>
              <th>Valor</th>
              <th>Data</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr key={row.id}>
                <td>
                  <span className="strong-link">
                    <Wrench size={15} /> {row.asset}
                  </span>
                </td>
                <td>{row.category}</td>
                <td>{row.description}</td>
                <td>{row.value}</td>
                <td>{row.date}</td>
                <td>
                  <Badge tone={row.status === "PAID" ? "success" : "warning"}>{row.status}</Badge>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Card>
  );
}
